import { makeLineItem } from "../utils/helpers";

const DEMO_CUSTOMERS = [
  "Meridian Displays", "Brooklyn Signworks", "Vault Creative Co.", "Hudson Fabrication",
  "Empire State Exhibits", "Chinatown Printing Co.", "SoHo Design Studio", "BK Maker Space",
  "Harlem Art Collective", "TriBeCa Retail Group", "Williamsburg Woodshop", "Greenpoint Signs",
  "Chelsea Gallery NYC", "Flatbush Community Center", "LIC Fabricators", "NoHo Branding Agency",
  "Bushwick Studios", "East Village Crafts", "Dumbo Design Lab", "Midtown Events Co.",
  "Park Slope Interiors", "Astoria Makers", "Queens Blvd Signs", "Prospect Heights Studio",
  "Crown Heights Creative", "Red Hook Workshop", "FiDi Corporate Events", "Murray Hill Displays",
  "Gramercy Park Design", "Kips Bay Printing",
];

const DEMO_MATERIALS = [
  { type: "Acrylic", color: "Frosted Glass", sheetSize: '12x20"', thickness: '1/4"' },
  { type: "Acrylic", color: "Clear", sheetSize: '12x20"', thickness: '1/8"' },
  { type: "Acrylic", color: "Black", sheetSize: '24x36"', thickness: '1/4"' },
  { type: "Foam", color: "White", sheetSize: '24x36"', thickness: '1/2"' },
  { type: "Metal", color: "Aluminum", sheetSize: '12x24"', thickness: '1/16"' },
  { type: "Wood", color: "Birch Plywood", sheetSize: '12x20"', thickness: '1/4"' },
  { type: "Acrylic", color: "White", sheetSize: '12x20"', thickness: '1/8"' },
  { type: "Metal", color: "Steel", sheetSize: '12x24"', thickness: '1/16"' },
  { type: "Wood", color: "Walnut Veneer", sheetSize: '12x20"', thickness: '1/4"' },
];

const DEMO_EMAILS = ["info@", "orders@", "hello@", "contact@", "sales@", "projects@", "admin@", "team@", "studio@", "design@"];
const DEMO_PHONES_AREA = [212, 718, 347, 646, 917];

function seededRng(seed) {
  let s = seed;
  return () => {
    s = (s * 16807 + 7) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

export function generateDemoJobs() {
  const jobs = [];
  const months = [
    { y: 2025, m: 7 }, { y: 2025, m: 8 }, { y: 2025, m: 9 },
    { y: 2025, m: 10 }, { y: 2025, m: 11 }, { y: 2025, m: 12 },
    { y: 2026, m: 1 }, { y: 2026, m: 2 }, { y: 2026, m: 3 },
  ];
  const used = [];
  let id = 1;
  let jobNum = 1000;
  const rand = seededRng(42);

  for (const { y, m } of months) {
    const cnt = 3 + Math.floor(rand() * 5);
    const dim = new Date(y, m, 0).getDate();
    const days = Array.from({ length: cnt }, () => 1 + Math.floor(rand() * dim)).sort((a, b) => a - b);
    for (let i = 0; i < cnt; i++) {
      const profit = 500 + Math.floor(rand() * 7500);
      const mg = 0.6 + rand() * 0.3;
      const cc = Math.round(profit / mg);
      const oc = cc - profit;
      let ci = Math.floor(rand() * DEMO_CUSTOMERS.length);
      let t = 0;
      while (used.slice(-8).includes(ci) && t < 20) {
        ci = Math.floor(rand() * DEMO_CUSTOMERS.length);
        t++;
      }
      used.push(ci);
      jobNum++;

      // Generate 1-3 line items
      const numLines = 1 + Math.floor(rand() * 3);
      const lineItems = [];
      for (let li = 0; li < numLines; li++) {
        const mat = DEMO_MATERIALS[Math.floor(rand() * DEMO_MATERIALS.length)];
        lineItems.push({
          id: id * 100 + li,
          type: mat.type,
          color: mat.color,
          sheetSize: mat.sheetSize,
          thickness: mat.thickness,
          partsPerSheet: 2 + Math.floor(rand() * 10),
          partsNeeded: 10 + Math.floor(rand() * 200),
        });
      }

      const laborHours = String(2 + Math.floor(rand() * 18));
      const laborRate = String(15 + Math.floor(rand() * 10));
      const employeeIds = [1, 2, 3, 4];
      const selectedEmployee = String(employeeIds[Math.floor(rand() * employeeIds.length)]);
      const jobTypes = ["Laser Cutting", "3D Printing", "UV Printing", "CNC"];
      const jobType = jobTypes[Math.floor(rand() * jobTypes.length)];
      const custName = DEMO_CUSTOMERS[ci];
      const emailPrefix = DEMO_EMAILS[Math.floor(rand() * DEMO_EMAILS.length)];
      const areaCode = DEMO_PHONES_AREA[Math.floor(rand() * DEMO_PHONES_AREA.length)];

      jobs.push({
        id: id++,
        jobNumber: `JOB-${String(jobNum).padStart(4, "0")}`,
        date: `${y}-${String(m).padStart(2, "0")}-${String(Math.min(days[i], dim)).padStart(2, "0")}`,
        customer: custName,
        customerEmail: `${emailPrefix}${custName.toLowerCase().replace(/[^a-z]/g, "").slice(0, 10)}.com`,
        customerPhone: `(${areaCode}) ${300 + Math.floor(rand() * 700)}-${1000 + Math.floor(rand() * 9000)}`,
        customerCost: cc,
        ourCost: oc,
        profit,
        lineItems,
        laborHours,
        laborRate,
        selectedEmployee,
        jobType,
      });
    }
  }
  return jobs;
}

export function generateDemoProgress() {
  const rand = seededRng(99);
  const items = [];
  const names = [
    "Vault Creative Co.", "Park Slope Interiors", "Greenpoint Signs", "Dumbo Design Lab",
    "FiDi Corporate Events", "Astoria Makers", "Chelsea Gallery NYC", "Crown Heights Creative",
  ];
  const emails = ["info@", "orders@", "hello@", "contact@", "sales@", "projects@", "admin@", "team@"];

  for (let i = 0; i < 8; i++) {
    const profit = 500 + Math.floor(rand() * 7500);
    const mg = 0.6 + rand() * 0.3;
    const cc = Math.round(profit / mg);
    const oc = cc - profit;
    const day = 1 + Math.floor(rand() * 10);
    const progressJobTypes = ["Laser Cutting", "3D Printing", "UV Printing", "CNC"];
    const pJobType = progressJobTypes[Math.floor(rand() * progressJobTypes.length)];
    items.push({
      id: 5000 + i,
      jobNumber: `JOB-${String(1042 + i).padStart(4, "0")}`,
      dateOpened: `2026-03-${String(day).padStart(2, "0")}`,
      customerName: names[i],
      customerEmail: `${emails[i]}${names[i].toLowerCase().replace(/[^a-z]/g, "").slice(0, 8)}.com`,
      customerPhone: `(${212 + Math.floor(rand() * 600)}) ${300 + Math.floor(rand() * 700)}-${1000 + Math.floor(rand() * 9000)}`,
      customerCost: cc,
      ourCost: oc,
      profit,
      jobType: pJobType,
      lineItems: [makeLineItem()],
      laborHours: String(2 + Math.floor(rand() * 18)),
      laborRate: String(15 + Math.floor(rand() * 10)),
      selectedEmployee: "",
      profitMultiplier: "",
      customerPriceInput: String(cc),
      profitDriver: "price",
    });
  }
  return items;
}

export function generateDemoExpenses() {
  const rand = seededRng(77);
  const expenses = [];
  let id = 9000;

  const purchasers = ["Daniel - Personal Card", "Jonathan - Personal Card", "Company Card", "Company Account"];
  const items = [
    { cat: "Filament", desc: "PLA+ 1kg Spool", brand: "Hatchbox", color: "Black", sku: "HB-PLA-BLK-1KG", costs: [22, 25, 28] },
    { cat: "Filament", desc: "PETG 1kg Spool", brand: "Polymaker", color: "White", sku: "PM-PETG-WHT-1KG", costs: [26, 30] },
    { cat: "Filament", desc: "TPU Flexible 750g", brand: "eSUN", color: "Clear", sku: "ES-TPU-CLR-750", costs: [32, 35] },
    { cat: "Filament", desc: "PLA Matte 1kg", brand: "Polymaker", color: "Gray", sku: "PM-PLA-GRY-1KG", costs: [24, 27] },
    { cat: "Acrylic", desc: "Frosted Glass Sheet 12x20", brand: "Inventables", color: "Frosted", sku: "INV-ACR-FG-1220", costs: [18, 22] },
    { cat: "Acrylic", desc: "Clear Cast Sheet 24x36", brand: "Inventables", color: "Clear", sku: "INV-ACR-CL-2436", costs: [38, 45] },
    { cat: "Acrylic", desc: "Black Acrylic 12x20 (10pk)", brand: "Canal Plastics", color: "Black", sku: "CP-ACR-BLK-10", costs: [165, 180] },
    { cat: "Hardware", desc: "M3 Screw Assortment Kit", brand: "Amazon Basics", color: "N/A", sku: "AB-M3-KIT-500", costs: [15, 18] },
    { cat: "Hardware", desc: "T-Slot Nuts & Bolts Set", brand: "McMaster-Carr", color: "N/A", sku: "MC-TSLOT-SET", costs: [42, 55] },
    { cat: "Hardware", desc: "Heat Set Insert Kit", brand: "McMaster-Carr", color: "N/A", sku: "MC-HSI-M3-100", costs: [28, 32] },
    { cat: "Parts", desc: "Nozzle Replacement Pack (5x)", brand: "Prusa", color: "N/A", sku: "PR-NOZ-04-5PK", costs: [20, 24] },
    { cat: "Parts", desc: "Laser Tube Replacement", brand: "Boss Laser", color: "N/A", sku: "BL-TUBE-80W", costs: [480, 520] },
    { cat: "Parts", desc: "Print Bed PEI Sheet", brand: "Prusa", color: "N/A", sku: "PR-PEI-MK4", costs: [35, 40] },
    { cat: "Shipping Supplies", desc: "Bubble Mailers 100pk", brand: "Uline", color: "N/A", sku: "UL-BM-8x12-100", costs: [45, 52] },
    { cat: "Shipping Supplies", desc: "Packing Tape 6-Roll", brand: "Uline", color: "Clear", sku: "UL-TAPE-CLR-6", costs: [18, 22] },
    { cat: "Shipping Supplies", desc: "Corrugated Boxes 25pk", brand: "Uline", color: "N/A", sku: "UL-BOX-12-25", costs: [38, 45] },
    { cat: "Software", desc: "Adobe Creative Cloud Monthly", brand: "Adobe", color: "N/A", sku: "ADOBE-CC-MO", costs: [55, 55] },
    { cat: "Subscriptions", desc: "Fusion 360 Annual", brand: "Autodesk", color: "N/A", sku: "AD-F360-YR", costs: [495, 495] },
    { cat: "Subscriptions", desc: "Canva Pro Monthly", brand: "Canva", color: "N/A", sku: "CANVA-PRO-MO", costs: [13, 13] },
    { cat: "Office Expenses", desc: "Printer Paper 5-Ream", brand: "Amazon Basics", color: "White", sku: "AB-PAPER-5RM", costs: [28, 32] },
    { cat: "Office Expenses", desc: "Label Maker Tape 3pk", brand: "Brother", color: "N/A", sku: "BRO-TZE-3PK", costs: [22, 25] },
    { cat: "Machinery", desc: "Exhaust Fan Upgrade", brand: "Home Depot", color: "N/A", sku: "HD-EXFAN-6IN", costs: [89, 120] },
  ];

  const months = [
    { y: 2025, m: 7 }, { y: 2025, m: 8 }, { y: 2025, m: 9 },
    { y: 2025, m: 10 }, { y: 2025, m: 11 }, { y: 2025, m: 12 },
    { y: 2026, m: 1 }, { y: 2026, m: 2 }, { y: 2026, m: 3 },
  ];

  for (const { y, m } of months) {
    const cnt = 4 + Math.floor(rand() * 6);
    const dim = new Date(y, m, 0).getDate();
    for (let i = 0; i < cnt; i++) {
      const item = items[Math.floor(rand() * items.length)];
      const day = 1 + Math.floor(rand() * dim);
      const cost = item.costs[Math.floor(rand() * item.costs.length)];
      const purchaser = purchasers[Math.floor(rand() * purchasers.length)];
      const quantity = 1 + Math.floor(rand() * 4);
      expenses.push({
        id: id++,
        date: `${y}-${String(m).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
        cost: String(cost),
        quantity: String(quantity),
        category: item.cat,
        description: item.desc,
        brand: item.brand,
        color: item.color,
        sku: item.sku,
        purchaser,
      });
    }
  }
  return expenses;
}
